import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import type { CustomAccordionProps } from "@components/Accordion/Accordion.types";

const Accordion: React.FC<CustomAccordionProps> = ({
  testId,
  summary,
  children,
  isTransparent,
  action,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <MuiAccordion
      {...rest}
      disableGutters
      square
      elevation={0}
      data-testid={testId}
      className={"!rounded-md bg-white border border-gray-200 no-border"}
      sx={{
        "&.MuiAccordion-root:before": {
          display: "none",
        },
        "& .MuiAccordionDetails-root": {
          paddingLeft: "24px",
          paddingRight: "24px",
        },
        "& .MuiAccordionSummary-root": {
          backgroundColor: !isTransparent ? "#F7F8FA" : undefined, // collapsed background
        },
        "&.Mui-expanded .MuiAccordionSummary-root": {
          backgroundColor: !isTransparent ? "#EBF0F6" : undefined, // expanded background
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        className={"!min-h-[56px] gap-2 no-print"}
      >
        <div className="flex flex-1 items-center justify-between gap-4">
          {typeof summary === "string" ? (
            <Typography sx={{ fontWeight: theme.typography.fontWeightBold }} className="text-sm">
              {summary}
            </Typography>
          ) : (
            summary
          )}
          {action ? (
            <div
              className="flex-shrink-0"
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            >
              {action}
            </div>
          ) : null}
        </div>
      </AccordionSummary>
      <AccordionDetails className="!pt-0">{children}</AccordionDetails>
    </MuiAccordion>
  );
};

export default Accordion;
